import PlainTextCell from 'components/PlainTextCell';

type Props = {
  rowData: Pick<SentinelTeam, 'owner' | 'scheduledForDeletionAt'>;
};

export default function OwnerCell({
  rowData: { owner, scheduledForDeletionAt },
}: Props) {
  return (
    <PlainTextCell
      color={scheduledForDeletionAt ? 'alaskanHusky' : undefined}
      topLine={owner?.email}
    />
  );
}
